module.exports = __webpack_public_path__ + "img/pro_ten_6.c06d26ef.jpg";